import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'referral.modal.invite_friends.title',
        defaultMessage: 'Invite friends',
    },
    subtitle: {
        id: 'referral.modal.invite_friends.subtitle.text',
        defaultMessage: 'Invite a friend with your referral code or link. Earn a reward every time they trade.',
    },
    learnMore: {
        id: 'referral.modal.invite_friends.learn_more',
        defaultMessage: 'Learn more',
    },
    learnMoreLink: {
        id: 'referral.modal.invite_friends.learn_more.link',
        defaultMessage: '#',
    },
    referralCode: {
        id: 'referral.modal.invite_friends.referral_code',
        defaultMessage: 'Referral code',
    },
    accrued: {
        id: 'referral.modal.invite_friends.accrued',
        defaultMessage: 'Accrued',
    },
    paid: {
        id: 'referral.modal.invite_friends.paid',
        defaultMessage: 'Paid out',
    },
    earned: {
        id: 'referral.modal.invite_friends.earned',
        defaultMessage: 'Total earned',
    },
    referralLink: {
        id: 'referral.modal.invite_friends.referral_link',
        defaultMessage: 'Referral link',
    },
})
